import React from 'react';
import { Text } from 'react-konva';

interface TextLabelProps {
  x: number;
  y: number;
  text: string | number;
  color: string;
}

const TextLabel: React.FC<TextLabelProps> = ({ x, y, text, color }) => {
  return (
    <Text
      x={x - 7}
      y={y - 7}
      width={16}
      height={16}
      text={typeof text === 'string' ? text : text.toString()}
      fontSize={11}
      fontFamily="Arial"
      fill={color}
      align="center"
      verticalAlign="middle"
    />
  );
};

export default TextLabel;
